import React, { useEffect, useState, JSX } from 'react';

type VerbsProps = {
  verbs: string[];
};

export const Verbs = ({ verbs }: VerbsProps) => {
  const [current, setCurrent] = useState<JSX.Element | null>(null);

  const texts = verbs.map((item, index) => (
    <div key={`verb_${index}`} className="min-w-80 flex justify-center">
      <span className="animate-fadeInOut text-xxs md:text-xs lg:text-sm font-bold font-sans">
        {item}
      </span>
    </div>
  ));
  useEffect(() => {
    const nextItem = texts.shift();
    if (nextItem) {
      setCurrent(nextItem);
    }
    const intervalId = setInterval(() => {
      if (texts.length >= 1) {
        const nextItem = texts.shift();
        if (nextItem) {
          setCurrent(nextItem);
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return <>{current}</>;
};
